import * as React from "react";
import type { SVGProps } from "react";

const SvgSummaryFooterGeneralCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={25}
    viewBox="0 0 26 25"
    {...props}
  >
    <path
      fill="#55449A"
      fillRule="evenodd"
      d="M4.457 11.644c-1.22 0-2.212.992-2.212 2.212v3.214c0 1.22.992 2.213 2.212 2.213h1.268v-7.64zm0 8.884A3.46 3.46 0 0 1 1 17.07v-3.214c0-1.227.663-2.375 1.73-2.993l.16-.092.002-.184a9.82 9.82 0 0 1 2.893-6.885 9.82 9.82 0 0 1 6.99-2.896c2.058 0 4.032.628 5.708 1.815a9.87 9.87 0 0 1 3.565 4.64.626.626 0 0 1-.586.839.62.62 0 0 1-.582-.406 8.68 8.68 0 0 0-8.106-5.643c-4.502 0-8.286 3.515-8.615 8.001l-.025.347h2.214c.343 0 .622.28.622.623v8.884a.623.623 0 0 1-.622.622zm15.365-1.245h1.268a2.216 2.216 0 0 0 2.214-2.213v-3.214c0-1.22-.993-2.212-2.214-2.212h-1.268zm-7.048 5.073a1.569 1.569 0 1 1 1.373-2.328l.037.068.378.067 2.748.002c.7 0 1.268-.568 1.268-1.267v-9.876c0-.344.28-.623.623-.623h1.89a3.46 3.46 0 0 1 3.457 3.457v3.214a3.46 3.46 0 0 1-3.458 3.458h-1.268v.323c0 1.411-1.126 2.559-2.512 2.559h-2.72l-.406.07-.037.067a1.57 1.57 0 0 1-1.373.809"
    />
  </svg>
);
export default SvgSummaryFooterGeneralCall;
